import * as React from "react";
import {CustomPencilIcon} from "../icons/custom-pencil-icon";
import {CustomHomeIcon} from "../new-icons/custom-home-icon";
import {CustomBookListIcon} from "../new-icons/custom-book-list-icon";
import {CustomPersonIcon} from "../new-icons/custom-person-icon";

export const AuthorMenu: IMenuOption[] = [
    {
        link: '/dashboard',
        icon: () => <CustomHomeIcon/>,
        label: 'menu.home',
        permission: '',
        matchUrl: ['/dashboard']
    },
    {
        link: '/author/profile',
        icon: () => <CustomPersonIcon style={{color: '#CDBDDB'}}/>,
        label: 'menu.profile',
        permission: '',
        matchUrl: ['/author/profile', '/author/edit-profile']
    },
    {
        link: '/author/add-manuscript',
        icon: () => <CustomPencilIcon style={{height: '24px', width: '24px', padding: '3px'}}/>,
        label: 'menu.addManuscript',
        permission: '',
        matchUrl: ['/author/add-manuscript']
    },
    {
        link: '/author/books',
        icon: () => <CustomBookListIcon/>,
        label: 'menu.myManuscripts',
        permission: '',
        matchUrl: ['/author/books', '/author/book', '/author/edit-manuscript/']
    },
];

export interface IMenuOption {
    link: string,
    icon: () => any,
    label: string,
    permission: string,
    matchUrl: string[]
}